import moment from "moment";
import { createCrudActions } from "../utils/crudGenerator";
import { axios } from "../connection/ConnectionHandler";
import { SHOW_NOTIFICATION, UPDATE_TIMECHANGEREQUEST } from "../constants";
import { API } from "../constants/api";

const formatTimechangerequests = (data) => {
	if (!data) {
		return [];
	}
	const formatItem = (item) => ({
		...item,
		label: `${item.name}`,
		value: item._id,
		endDate: item.endDate && moment(item.endDate),
		startDate: item.startDate && moment(item.startDate),
	});

	if (Array.isArray(data)) {
		return data.map(formatItem);
	}
	return formatItem(data);
};

export const {
	fetch: fetchTimechangerequests,
	create: createTimechangerequest,
	update: updateTimechangerequest,
	delete: deleteTimechangerequests,
} = createCrudActions("TIMECHANGEREQUEST", "Solicitud de Cambio De Fichaje", formatTimechangerequests);

export const approveTimechangerequest = (id) => async (dispatch) => {
	try {
		const response = await axios.put(`${API.timechangerequests.base}/${id}/approve`);
		const formattedData = formatTimechangerequests(response.data);
		dispatch({ type: UPDATE_TIMECHANGEREQUEST, payload: formattedData });
		dispatch({
			type: SHOW_NOTIFICATION,
			payload: {
				show: true,
				status: "success",
				message: "Solicitud aprobada con éxito.",
			},
		});
		return response.status;
	} catch (err) {
		dispatch({
			type: SHOW_NOTIFICATION,
			payload: {
				show: true,
				status: "error",
				message: "Error al aprobar la solicitud.",
			},
		});
		return err;
	}
};

export const rejectTimechangerequest = (id, rejectionReason) => async (dispatch) => {
	try {
		const response = await axios.put(`${API.timechangerequests.base}/${id}/reject`, { rejectionReason });
		const formattedData = formatTimechangerequests(response.data);
		dispatch({ type: UPDATE_TIMECHANGEREQUEST, payload: formattedData });
		dispatch({
			type: SHOW_NOTIFICATION,
			payload: {
				show: true,
				status: "warning",
				message: "Solicitud rechazada.",
			},
		});
		return response.status;
	} catch (err) {
		dispatch({
			type: SHOW_NOTIFICATION,
			payload: {
				show: true,
				status: "error",
				message: "Error al rechazar la solicitud.",
			},
		});
		return err;
	}
};
